console.log('init_regular_games.js loaded!');

/* css for the specific page */
import "./pages-assets/games/regular-games/regular-games.css";


   

/* scripts for the specific page */
import "./pages-assets/games/regular-games/regular-games.js";